<div class="section">
    <div class="width-50">
        <h4>Take photo</h4>
        <div class="warning-block">
            <i class="icon-info"></i>
            <span>There are passport applications that can be helpful in capturing a compliant photo.</span>
        </div>

        <p><b>Please, follow the rules for a better result</b></p>

        <ol>
            <li>Jpg format.</li>
            <li>Forward-facing with your entire face, head, shoulders, and eyes completely visible.</li>
            <li>Clear, well-lit photo of only you.</li>
            <li>Plain white or off-white background.</li>
            <li>No sunglasses or hats.</li>
            <li>No black and white photos.</li>
            <li>Maximum size of file is 10 Mb.</li>
            <li>The image should be atleast 800 pixels.</li>
        </ol>
        <div class="info-message">
            If the photo does not meet these rules, it will be declined.
        </div>
        <p><b>Good and bad examples</b></p>

        <div class="imgs-wrapper">
            <div class="img-wrp">
                <img src="/assets/img/employee-badge-request/photo-03.jpg" alt="Good">
                <i class="icon-tick"></i>
            </div>
            <div class="img-wrp">
                <img src="/assets/img/employee-badge-request/photo-02.jpg" alt="Bad">
                <i class="icon-close"></i>
            </div>
            <div class="img-wrp">
                <img src="/assets/img/employee-badge-request/photo-01.jpg" alt="Bad">
                <i class="icon-close"></i>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
        <div class="width-50 d-flex justify-content-end testclass">
            <ui-camera
                [userCanTakePhoto]="userCanTakePhoto"
                [autoplay]="!userPhotoUrl"
                [defaultConfig]="cameraConfig"
                [userPhotoUrl]="userPhotoUrl"
                [newFileName]="newFileName"
                (onPhotoTaken)="onPhotoTaken($event)"
            >
                <ng-container *ngIf="!photoData">
                    <span *ngIf="userCanTakePhoto" class="separator">or</span>
                    <ui-upload-photo
                        [newFileName]="newFileName"
                        [uploadConfig]="uploadConfig"
                        [isVisitorRequest]="isVisitorRequest"
                        (onUploadPhoto)="onPhotoUploaded($event)"
                    >
                    </ui-upload-photo>
                </ng-container>
                <button *ngIf="photoData" (click)="deletePhoto()" class="button secondary" [style.order]="-1">Delete</button>
                <ng-container *isUS>
                    <ng-container *ngIf="!photoData && canUseCurrentImage">
                        <span class="separator">or</span>
                        <button class="with-icon button secondary" (click)="useCurrentPhoto()">Use current</button>
                    </ng-container>
                </ng-container>
            </ui-camera>
        </div>
</div>
